import { IForm } from '@/components/types'
import { getBeforeDate } from '@/utils/utils'

export const searchFormConfig: IForm = {
  formItems: [
    {
      label: '群名称',
      field: 'groupName',
      clearable: true,
      type: 'input',
      placeholder: '请输入名称'
    },
    {
      field: 'date',
      type: 'datepicker',
      label: '选择日期',
      clearable: false,
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    },
    {
      field: 'timeRange',
      type: 'select',
      label: '时间段',
      placeholder: '请选择时间段',
      change(value: any) {
        return [getBeforeDate(value), getBeforeDate('today')]
      },
      descField: 'date',
      options: [
        { title: '今天', value: 'today' },
        { title: '近7天', value: '7_days' },
        { title: '近1个月', value: '1_month' }
      ]
    }
  ]
}
